import { useContext } from 'react'
import ParagraphContext from '../ParagraphContext'

const useParagraphContext = (component, force = true) => {
  const context = useContext(ParagraphContext)
  if (force && !context) {
    const err = new Error(`<${component} /> is missing ParagraphContext`)
    if (Error.captureStackTrace)
      Error.captureStackTrace(err, useParagraphContext)
    throw err
  }
  return context
}

export default useParagraphContext
